// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"96ac8e8f","278":"3f1cfce1","295":"95344aed","884":"24950c3b","968":"e13a86ec"}[chunkId] + ".css";
};